import { Routes } from '@angular/router'
import { ApplicationPrivateRoutesEnum, ApplicationPublicRoutesEnum } from './shared/models/enums/application-routes.enum'
import { AuthenticationService } from './shared/services/authentication.service'
import { CanActivateNoRoles } from './shared/services/can-activate.guard.service'
import { PublicPageGuard } from './shared/services/public-page.service.guard'

export const routes: Routes = [
   { path: '', redirectTo: ApplicationPrivateRoutesEnum.MAIN_PAGE, pathMatch: 'full' },
   {
      path: ApplicationPrivateRoutesEnum.MAIN_PAGE,
      canActivate: [AuthenticationService],
      loadChildren: () => import('./core/pages/private/main-page/main-page.routes').then((m) => m.MAIN_PAGE_ROUTES),
   },
   {
      path: ApplicationPublicRoutesEnum.REGISTER,
      canActivate: [PublicPageGuard],
      loadComponent: () => import('./core/pages/public/register-page/register-page.component'),
   },
   {
      path: ApplicationPublicRoutesEnum.RESET_PASSWORD,
      canActivate: [PublicPageGuard],
      loadComponent: () => import('./core/pages/public/reset-password/reset-password.component'),
   },
   {
      path: ApplicationPublicRoutesEnum.REQUEST_CHANGE_PASSWORD,
      canActivate: [PublicPageGuard],
      loadComponent: () => import('./core/pages/public/request-change-password/request-change-password.component'),
   },
   {
      path: ApplicationPublicRoutesEnum.ACCESS_DENIED,
      canActivate: [AuthenticationService, CanActivateNoRoles],
      loadComponent: () => import('./core/pages/public/access-denied-page/access-denied-page.component'),
   },
   {
      path: ApplicationPublicRoutesEnum.ACCOUNT_ACTIVATED_CONFIRMATION,
      canActivate: [PublicPageGuard],
      loadComponent: () => import('./core/pages/public/account-activated-confirmation/account-activated-confirmation.component'),
   },
]
